import React, { useEffect, useState } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
  Table,
  Label,
  Input,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { URLS } from "../../Url"
import axios from "axios"

function DigitalBrochure() {
  const [form, setform] = useState([])

  const [forms, setforms] = useState([])

  const handlechange = e => {
    const myform = { ...forms }
    myform[e.target.name] = e.target.value
    setforms(myform)
  }

  useEffect(() => {
    GetAllBroucher()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const GetAllBroucher = () => {
    var token = datas

    axios
      .post(
        URLS.GetUserCount,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setform(res.data.postlimitcount)
        setforms(res.data.postlimitcount)
      })
  }
  const [modal_small, setmodal_small] = useState(false)
  function tog_small() {
    setmodal_small(!modal_small)
  }

  const getpopup1 = () => {
    tog_small()
  }

  const submibooking = e => {
    e.preventDefault()
    changstatus()
  }

  const changstatus = () => {
    var token = datas
    const Data = {
      postCount: forms.postCount,
      listingCount: forms.listingCount,
      uploadCount: forms.uploadCount,
      cashBookCount: forms.cashBookCount,
      productsLimit: forms.productsLimit,
      postDisplayTimeInHours: forms.postDisplayTimeInHours,
      coins: forms.coins,
      // platformFee: forms.platformFee,
    }

    axios
      .put(URLS.UpdateUserCount, Data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            setmodal_small(false)
            GetAllBroucher()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home " breadcrumbItem="User Count" />
          <Row>
            <Col md={12}>
              <Card>
                <CardHeader className="bg-white"></CardHeader>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <div style={{ float: "right" }}>
                        {Roles?.SettingsEdit == true ||
                        Roles?.accessAll == true ? (
                          <>
                            <Button
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Edit Booking"
                              onClick={() => {
                                getpopup1(form)
                              }}
                              className="mr-5 mb-1 m-1 "
                              color="success"
                            >
                              <div className="d-flex">
                                <small>
                                  <i className="bx bx-edit m-1"></i>
                                  Edit
                                </small>
                              </div>
                            </Button>{" "}
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex justified-content-centerd-flex justify-content-center">
                    <Col md={8}>
                      <div>
                        <div className="table-rep-plugin mt-4 table-responsive">
                          <Table hover className="table table-bordered mb-4">
                            <thead>
                              <tr className="text-center">
                                <th style={{ width: "50%" }}>Listing Count</th>
                                <td style={{ width: "50%" }}>
                                  {form.listingCount}
                                </td>
                              </tr>
                              <tr className="text-center">
                                <th style={{ width: "50%" }}>Poster's Count</th>
                                <td style={{ width: "50%" }}>
                                  {form.postCount}
                                </td>
                              </tr>
                              <tr className="text-center">
                                <th style={{ width: "50%" }}>Upload Count</th>
                                <td style={{ width: "50%" }}>
                                  {form.uploadCount}
                                </td>
                              </tr>
                              <tr className="text-center">
                                <th style={{ width: "50%" }}>CashBook Count</th>
                                <td style={{ width: "50%" }}>
                                  {form.cashBookCount}
                                </td>
                              </tr> 
                              <tr className="text-center">
                                <th style={{ width: "50%" }}>Products Limit</th>
                                <td style={{ width: "50%" }}>
                                  {form.productsLimit}
                                </td>
                              </tr>
                              <tr className="text-center">
                                <th style={{ width: "50%" }}>Display Time Hours</th>
                                <td style={{ width: "50%" }}>
                                  {form.postDisplayTimeInHours}
                                </td>
                              </tr>
                              <tr className="text-center">
                                <th style={{ width: "50%" }}>Coins Value</th>
                                <td style={{ width: "50%" }}>
                                  {form.coins}
                                </td>
                              </tr>
                            
                              {/* <tr className="text-center">
                                <th style={{ width: "50%" }}>Platform Fee</th>
                                <td style={{ width: "50%" }}>
                                  {form.platformFee}
                                </td>
                              </tr> */}
                            </thead>
                          </Table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="md"
            isOpen={modal_small}
            toggle={() => {
              tog_small()
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="mySmallModalLabel">
                Edit User Count
              </h5>
              <button
                onClick={() => {
                  setmodal_small(false)
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form
                onSubmit={e => {
                  submibooking(e)
                }}
              >
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Listing Count<span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Listing Count"
                        required
                        value={forms.listingCount}
                        name="listingCount"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Poster's Count<span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Poster's Count"
                        required
                        value={forms.postCount}
                        name="postCount"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Upload Count<span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Upload Count"
                        required
                        value={forms.uploadCount}
                        name="uploadCount"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        CashBook Count<span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter CashBook Count"
                        required
                        value={forms.cashBookCount}
                        name="cashBookCount"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Products Limit<span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Products Limit"
                        required
                        value={forms.productsLimit}
                        name="productsLimit"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  {/*  adding this columns */}
                  <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                      Display Time Hours<span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        // placeholder="Enter postDisplayTimeInHours"
                        required
                        value={forms.postDisplayTimeInHours}
                        name="postDisplayTimeInHours"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                   <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                      Coins Value <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        // placeholder="Enter coins"
                        required
                        value={forms.coins}
                        name="coins"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  {/* <Col md={6}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                      Platform Fee <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        // placeholder="Enter platformFee"
                        required
                        value={forms.platformFee}
                        name="platformFee"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col> */}
                </Row>
                <hr></hr>
                <div style={{ float: "right" }} className="m-2">
                  <Button className="m-1" type="submit">
                    Submit <i className="fas fa-check-circle"></i>
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>
        </Container>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default DigitalBrochure
